
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-tabs{
  display:grid;
}

.se-tabs--panel{
  display:none;
  padding:1.5rem 0;
}

.se-tabs--panel.active{
    display:block;
  }

.se-tabs--button{
  position:relative;
  background:var(--brand-neutral-white);
  color:var(--gray-800);
  font-weight:500;
  font-size:var(--fs-sm);
  font-family:var(--ff-dmsans);
  border:none;
  cursor:pointer;
}

.se-tabs--button.active::after{
      content:'';
      display:flex;
      height:3px;
      width:100%;
      background:var(--brand-primary-2);
      position:absolute;
      left:0;
    }

.se-tabs--button.mobile-button{
    font-weight:var(--fw-thin);
    background:var(--gray-100);
    color:var(--gray-800);
    padding:1rem 1.25rem;
    width:100%;
    text-align:start;
    position:relative;
  }

.se-tabs--button.mobile-button:focus{
      outline:none;
    }

.se-tabs--button.mobile-button:focus::after{
        position:absolute;
        content:'';
        width:100%;
        height:100%;
        outline:solid 2px var(--gray-800);
        left:0;
        top:0;
        z-index:1;
      }

.se-tabs--button.mobile-button.active::after{
        background:none;
        height:100%;
      }

.se-tabs--tablist-desktop{
  display:flex;
  gap:3rem;
  padding:1rem 0;
}

.se-tabs--tablist-mobile{
  display:flex;
  flex-direction:column;
  list-style:none;
  width:100%;
  height:100%;
  background-color:var(--gray-100);
  padding:0;
  margin:0;
  border:0 2px solid var(--brand-neutral-white);
}

.se-tabs--tablist-mobile.closed{
    display:none;
  }
`;